// extracted by mini-css-extract-plugin
export var container = "HomeSlider-module--container--fH8W7";